import { z } from 'zod';
import { CohortMetadata } from './metadata/cohorts.ts';

const getCohortLabels = (cohortData: CohortMetadata[]): string[] => cohortData
  .filter((cohort: CohortMetadata) => cohort.Region === 'ALL' && cohort.ICB === 'ALL' && cohort.AgeBucket === 'ALL')
  .map((cohort: CohortMetadata) => cohort.CohortLabel);

// A bit of a nasty hack to give Zod confidence that the enum is a tuple and not a mutable array.
const zodEnum = <T>(arr: T[]): [T, ...T[]] => arr as [T, ...T[]];

export const iterationCohortSchema = (cohortData: CohortMetadata[]) => {
  const cohortLabels = getCohortLabels(cohortData);

  return z.object({
    CohortLabel: z.enum(zodEnum(cohortLabels)).optional(),
    Priority: z.number().optional(),
  });
};

export type IterationCohort = z.infer<ReturnType<typeof iterationCohortSchema>>;

export default iterationCohortSchema;
